export const APP_STATES = {
  IDLE: 'idle',
  PLAYING: 'playing',
  CONTRIBUTING: 'uploading'
}

export default APP_STATES
